import { lazy, Suspense, useEffect } from "react";
import { Switch, useHistory, useLocation } from "react-router-dom";

import { SuspenceFallbackComponent } from "./components/SuspenceFallback";
import { NavigationComponent } from "./components/Navigation";
import { CustomRoute } from "./components/CustomRoute";
import { Routes } from "./utils/routes";
import "./utils/browser";

import { AppServiceInstance } from "./services/app";
import "./services/moment";
import "./services/storage";
import "./services/game";

import "react-calendar/dist/Calendar.css";
import "./styles/main.scss";

const WelcomePage = lazy(() => import("./pages/welcome"));
const GamesPage = lazy(() => import("./pages/games"));
const SeatPage = lazy(() => import("./pages/seat"));
const MomentPage = lazy(() => import("./pages/moment"));
const MomentoPage = lazy(() => import("./pages/momento"));
const AllMomentoPage = lazy(() => import("./pages/allMomento"));
const EditorPage = lazy(() => import("./pages/editor"));

export const App = (): JSX.Element => {
  const { pathname } = useLocation();
  useEffect(() => {
    AppServiceInstance.closeNavigationBar();
  }, [pathname]);

  const history = useHistory();
  useEffect(() => {
    AppServiceInstance.setHistory(history);
  }, []);

  return (
    <Suspense fallback={<SuspenceFallbackComponent />}>
      <NavigationComponent />
      <Switch>
        <CustomRoute exact path={Routes.WELCOME} Component={WelcomePage} />
        <CustomRoute exact path={Routes.GAMES} Component={GamesPage} />
        <CustomRoute exact path={Routes.SEAT} Component={SeatPage} />
        <CustomRoute exact path={Routes.MOMENT} Component={MomentPage} />
        <CustomRoute exact path={Routes.MOMENTO} Component={MomentoPage} />
        <CustomRoute exact path={Routes.ALL_MOMENTO} Component={AllMomentoPage} />
        <CustomRoute exact path={Routes.EDITOR} Component={EditorPage} />
      </Switch>
    </Suspense>
  );
};
